// TODO: ninesegsAnalyzer app からの依存をなくす
import * as R from 'remeda'

import {
  type PathGroupKey,
  pathGroupLabelI18nKeyMap,
  pathGroupScreenLabelMap,
  pathLabelI18nKeyMap,
} from '~/apps/ninesegsAnalyzer/routes/paths'

import { exists } from '../../generals'
import { type FigureInfo, type ScreenLabel } from '../figureInfo'

/**
 * FigureInfo を ScreenLabel に変換します。
 * i18n キーを返します。表示時は translateFigureInfoValue で翻訳してください。
 *
 * @param figureInfo - 変換する FigureInfo。
 * @returns 変換された ScreenLabel（i18n キー形式）。
 */
export function toScreenLabel(figureInfo: FigureInfo): ScreenLabel | undefined {
  const { pathKey, screenLabel } = figureInfo

  if (exists(screenLabel)) {
    return screenLabel
  }

  const pathGroupKeys = R.keys(pathGroupScreenLabelMap) as PathGroupKey[]
  const pathGroupKey = pathGroupKeys.find((pathGroupKey) =>
    (pathGroupScreenLabelMap[pathGroupKey] as (typeof pathKey)[]).includes(
      pathKey,
    ),
  )

  if (exists(pathGroupKey) && exists(pathKey)) {
    // i18n キーをそのまま返す（保存用）。表示時は translateFigureInfoValue で翻訳される
    return `${pathGroupLabelI18nKeyMap[pathGroupKey]} - ${pathLabelI18nKeyMap[pathKey]}`
  }

  return undefined
}
